export default {"src":"/_next/static/media/visa-icon.7bf51e74.svg","height":45,"width":70,"blurWidth":0,"blurHeight":0};